// Modalità "Thoth Coordinamento" (app desktop Windows / Electron): UI ridotta a Radar, Operai, Pianificazione, Turni.
// Attiva se lo user agent contiene "ThothCoordinamento" (impostato dall'app Electron) oppure con ?app=coord (persistito).
const KEY = "thoth_app_mode";

export function isCoordDesktop() {
  try {
    if (/ThothCoordinamento/i.test(navigator.userAgent)) return true;
    const p = new URLSearchParams(window.location.search);
    const v = p.get("app");
    if (v === "coord") { localStorage.setItem(KEY, "coord"); return true; }
    if (v === "full") { localStorage.removeItem(KEY); return false; }
    return localStorage.getItem(KEY) === "coord";
  } catch {
    return false;
  }
}

export const COORD_HOME = "/admin/radar";
